import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root'})
export class TeamMemberService {

   private activeTypeSource = new BehaviorSubject('default message');
   currentActiveType = this.activeTypeSource.asObservable();

   constructor() { }

   changeActiveType(type: string) {
      this.activeTypeSource.next(type);
   }

}
